export default [
  {
    id: 'Q1',
    componentType: 'question-screen',
    progress: '/product-advisor/images/progress/Ladebalken_Berge_1029x232px_2.png',
    questions: [
      { text: 'questions.q1.question', advice: 'questions.q1.advice' }
    ],
    answers: [
      { text: 'questions.q1.a1', action: 'jump:Q2', image: '/product-advisor/images/questions/q1/Produktberater_Wandern_92x81px.png' },
      { text: 'questions.q1.a2', action: 'jump:Q2', image: '/product-advisor/images/questions/q1/Produktberater_Mountaineering_92x81px.png' },
      { text: 'questions.q1.a3', action: 'jump:Q2', image: '/product-advisor/images/questions/q1/Produktberater_Kategoriebilder_Trail-Running_92x81px.png' },
      { text: 'questions.q1.a4', action: 'jump:Q2', image: '/product-advisor/images/questions/q1/Produktberater_Kategoriebilder_Trekking_92x81px.png' },
      { text: 'questions.q1.a5', action: 'jump:Q2', image: '/product-advisor/images/questions/q1/Produktberater_Kategoriebilder_Climbing_92x81px.png' },
      { text: 'questions.q1.a6', action: 'jump:Q2', image: '/product-advisor/images/questions/q1/Produktberater_MTB_92x81px.png' },
      { text: 'questions.q1.a7', action: 'jump:Q2', image: '/product-advisor/images/questions/q1/Produktberater_Skitour-Freeride_92x81px.png' },
      { text: 'questions.q1.a8', action: 'jump:Q3', image: '/product-advisor/images/questions/q1/Produktberater_Kategoriebilder_Kinder-tragen_92x81px.png' },
      { text: 'questions.q1.a9', action: 'jump:Q2', image: '/product-advisor/images/questions/q1/Produktberater_Alltag_92x81px.png' },
      { text: 'questions.q1.a10', action: 'jump:Q2', image: '/product-advisor/images/questions/q1/Produktberater_Reise_92x81px.png' },
    ]
  }
]